import { FETCH_HOME_SUCCESS } from "../actions/homeAction";

const initState = {
    home: [],
};

const homeReducer = (state = initState, action) => {
    if (action.type === FETCH_HOME_SUCCESS) {
        return {
            ...state,
            home: action.payload,
        };
    }

    return state;
};

export default homeReducer;
